import { cssTransition } from 'react-toastify';

const Fade = cssTransition({
   enter: `fade-in`,
   exit: `fade-out`,
   duration: [500, 800],
});

export default Fade;
